// Configuracion de pago pendiente
// Cambia "pendiente" a true para mostrar el aviso, false para ocultarlo
const PAYMENT_CONFIG = {
  pendiente: false,
  mensaje: 'Este sistema tiene un pago pendiente. Contáctenos para regularizar su cuenta.',
  contacto: ''
};

export default PAYMENT_CONFIG;
